export default "__VITE_ASSET__BRcZ$EjO__"